// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZD5HE","fullView":"styles_fullView__2U4lg"};